import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

const InvestorLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === 'SNBL') {
      sessionStorage.setItem('investorAuth', 'true');
      navigate('/investors');
    } else {
      setError(true);
      setTimeout(() => setError(false), 3000);
    }
  };

  return (
    <>
      <SEO 
        title="Acceso Inversores - KOMPA"
        description="Área restringida para inversores de KOMPA"
        pathname="/investor-login"
      />
      <div className="min-h-screen bg-gradient-to-br from-[#1A1A1A] via-[#2A2A2A] to-[#1A1A1A] flex items-center justify-center px-4 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-md"
        >
          <div className="bg-white/5 backdrop-blur-lg rounded-3xl p-8 border border-white/10">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F5A623] rounded-2xl mb-4">
                <Lock size={32} className="text-[#1A1A1A]" />
              </div>
              <h1 className="text-3xl font-black text-white mb-2">Portal de Inversores</h1>
              <p className="text-gray-400">Ingresa la contraseña para acceder</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Contraseña"
                  className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-[#F5A623] transition-colors"
                  autoFocus
                />
                {error && (
                  <motion.p
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-red-400 text-sm mt-2"
                  >
                    Contraseña incorrecta
                  </motion.p>
                )}
              </div>

              <motion.button
                type="submit"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="w-full px-8 py-4 bg-[#F5A623] text-[#1A1A1A] font-black rounded-xl hover:bg-[#FF9500] transition-all duration-300 flex items-center justify-center gap-2 text-lg"
              >
                Acceder
                <ArrowRight size={20} />
              </motion.button>
            </form>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default InvestorLogin;
